import { Component } from '@angular/core';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { TransactionService } from '../../../models/transactions/transactionService';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { SearchFilters } from '../../../models/search/searchFilters';
import { UIHelpers } from '../../../core/ui-helpers';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { TransactionDialogComponent } from '../transaction-dialog/transaction-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-transaction-table-view',
  templateUrl: './transaction-table-view.component.html',
  standalone: false,
})
export class TransactionTableViewComponent extends TableViewAbstractComponent {
  hideMID: boolean = false;
  loading = true;

  constructor(
    public transactionService: TransactionService,
    private uiErrorHandler: UIErrorHandler,
    private dialog: MatDialog,
    private router: Router,
  ) {
    super();
  }

  getRecordFromDataSource(transactionId: string): TransactionFacade {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == transactionId) {
        return this.dataSource.data[i];
      }
    }

    throw 'Transaction not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: SearchFilters,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<TransactionFacade>> {
    if (
      this.options.hiddenFields &&
      this.options.hiddenFields.includes('MID')
    ) {
      this.hideMID = true;
    }

    return this.transactionService
      .getPaged(query, {
        pageNum: pageNum,
        pageSize: pageSize,
        orderBy: 'name',
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        userId: this.options.userId ? this.options.userId : '',
        restrictToAction: this.options.restrictToAction,
        //allowRefund: this.options.allowRefund,
        merchantId: this.options.merchantId ? this.options.merchantId : '',
        customerId: this.options.customerId ? this.options.customerId : '',
        orderId: this.options.orderId ? this.options.orderId : '',
        invoiceNumber: this.options.invoiceNumber
          ? this.options.invoiceNumber
          : '',
        month: this.options.month ? this.options.month : '',
        year: this.options.year ? this.options.year : '',
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
        return new Page<TransactionFacade>({});
      }).finally(() => this.loading = false);
  }

  canQuery(): boolean {
    if (this.options) {
      return (
        (this.options && this.options.merchantId != undefined) ||
        this.options.customerId != undefined ||
        this.options.userId != undefined
      );
    }
    return false;
  }

  _selectRow_click(id: string) {
    if (this.options.selectAction == 'popup') {
      let ref = this.dialog.open(TransactionDialogComponent, {
        width: '500px',
        disableClose: false,
        data: {
          transactionId: id,
        },
      });

      this.router.events.subscribe(() => {
        ref.close();
      });

      //ref.afterClosed().subscribe()
    } else {
      this.selectRow_click(id);
    }
  }

  formatDate(
    date: string | undefined,
    defaultText: string | undefined,
  ): string {
    if (date) {
      return UIHelpers.formatDate(date);
    } else {
      return defaultText + '';
    }
  }
}
